import { render, staticRenderFns } from "./DiscussionCommentChangeActivationType.vue?vue&type=template&id=0b6b2e09&"
import script from "./DiscussionCommentChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./DiscussionCommentChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports